import { RecaptchaProvider } from '@/presentation/contexts/recaptcha/recaptcha-provider'
import { lazy, ReactNode } from 'react'

const UserProfilePage = lazy(() => import('@/presentation/pages/user-profile/user-profile-page'))
const UserInterestAreasSkillsPage = lazy(
  () => import('@pages/user-interest-areas-skills/user-interest-areas-skills-page')
)
const UserSettingsPage = lazy(() => import('@/presentation/pages/user-settings/user-settings-page'))
const UserSpacePage = lazy(() => import('@pages/user-space/user-space-page'))
const UserEnrollmentsPage = lazy(() => import('@pages/user-enrollments/user-enrollments-page'))

const UserEnrollmentDetailPage = lazy(
  () => import('@pages/user-enrollment-detail/user-enrollment-detail-page')
)

export const makeUserProfilePage = () => {
  return <UserProfilePage />
}

export const makeUserInterestAreasSkillsPage = () => {
  return <UserInterestAreasSkillsPage />
}

export const makeUserSettingsPage = () => {
  return (
    <RecaptchaProvider>
      <UserSettingsPage />
    </RecaptchaProvider>
  )
}

export const makeUserSpacePage = (): ReactNode => {
  return <UserSpacePage />
}

export const makeUserEnrollmentsPage = (): ReactNode => {
  return <UserEnrollmentsPage />
}

export const makeUserEnrollmentDetailPage = (): ReactNode => {
  return <UserEnrollmentDetailPage />
}
